import { Injectable } from '@angular/core';
import { SimpleMQ } from 'ng2-simple-mq';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { CommonService } from './common.service';
import { FilterPipe } from '../pipes/filter.pipe';

@Injectable()
export class FilterBoxService {
    dataArrayOutput: any[] = [];
    private dataArrayOutputSubject = new BehaviorSubject<any[]>(this.dataArrayOutput);

    constructor(private commonService: CommonService, private filterPipe: FilterPipe, private smq: SimpleMQ) {
	console.log("SRV|FILTER - ALIVE!");
	this.smq.subscribe('filter', e => this.receiveMsg(e));
    }

    receiveMsg(m) {
	console.log('SRV|FILTER - receiveMsg:', m);
	if(m){
	    let msgSender = m.sender;
	    let msgType = m.type;
	    let msgKey = m.key;
	    let msgValue = m.value;
	    switch(msgType){
		    default:

	    }
	}
    }

    sendMsg(name: string, type: any, key: any, value: any = null) {
	// Publish to queue name
	let m = {
	    sender: 'filter',
	    type: type,
	    key: key,
	    value: value,
	};
	console.log('SRV|FILTER - sendMsg:', m);
	this.smq.publish(name, m);
    }

    filter(dataArraySource, filterMap){
        this.dataArrayOutput = [];
        this.dataArrayOutput = this.filterPipe.filter(dataArraySource, filterMap);
        //console.log("SRV|FILTER | APPLYFILTER OK", filterMap, this.dataArrayOutput);
        this.dataArrayOutputSubject = new BehaviorSubject<any[]>(this.dataArrayOutput);
        return this.dataArrayOutputSubject;
    }
}
